import $ from 'jquery';

export const Modal = {
  modal: null,
  yesBtn: null,
  noBtn: null,
  body: null,
  header: null,
  onYes: null,
  onHide: null,

  init: function () {
    let me = this;

    this.yesBtn = $('<button>').attr({type: 'button'}).addClass('btn btn-primary').text('Yes');
    this.noBtn = $('<a>').attr({href: 'javascript:;'}).addClass('text-secondary').attr('data-bs-dismiss', 'modal').text('Cancel').css({ 'margin-top': '15px' });
    this.header = $('<div>').addClass('modal-header').css({ 'border-bottom': 0, display: 'block' }).append(
      $('<div>').addClass('text-content').css({ 'font-weight': 'bold' }).text('Something Went Wrong')
    );
    this.body = $('<div>').addClass('modal-body').append(
      $('<div>').addClass('text-content').text('Are you sure?')
    );

    this.modal = $('<div>').addClass('modal fade common-modal').attr({role: 'dialog', 'aria-hidden': 'true', 'aria-label': 'Notification'}).append(
      $('<div>').addClass('modal-dialog').append(
        $('<div>').addClass('modal-content').append(
          $('<i class="fas fa-xmark" data-bs-dismiss="modal"></i>')
        ).append(
          this.header
        ).append(
          this.body
        ).append(
          $('<div>').addClass('modal-footer').append(
            this.yesBtn
          ).append(
            $('<div>')
          ).append(
            this.noBtn
          )
        )
      )
    );

    this.yesBtn.click(function () {
      me.onYes && me.onYes("yes");
    });

    this.modal.on('hidden.bs.modal', function (onClose) {
      me.onHide && me.onHide();
    });

    $('body').append(this.modal);
  },

  show: function (cfg) {
    this.yesBtn.text(cfg.yes || 'Yes');
    this.noBtn.text(cfg.no || 'Cancel');
    this.body.find('.text-content').text(cfg.body || 'Are you sure?');
    this.modal.find('.modal-content > .modal-type-icon').remove();

    cfg.type = cfg.type || 'error';

    let iconHtml = '';

    if(cfg.type === 'custom') {
      this.header.find('.text-content').html(cfg.title);
      this.modal.find('.modal-content').attr({ 'class': 'modal-content custom ' + cfg.className });

      if(cfg?.className?.split(' ').includes('sent-icon')){
        iconHtml = '<span class="modal-type-icon"><i class="fa fa-paper-plane"></i></span>';
      }else{
        iconHtml = ''
      }
    } else if(cfg.type === 'message') {
      iconHtml = '<span class="modal-type-icon"><i class="fa fa-comment "></i></span>';
      this.header.find('.text-content').html('Message');
      this.modal.find('.modal-content').attr({ 'class': 'modal-content message' });
    } else if(cfg.type === 'warning') {
      iconHtml = '<span class="modal-type-icon"><i class="fa fa-triangle-exclamation"></i></span>';
      this.header.find('.text-content').html('Warning');
      this.modal.find('.modal-content').attr({ 'class': 'modal-content error' });
    } else if(cfg.type === 'success') {
      iconHtml = '<span class="modal-type-icon"><i class="fa fa-check"></i></span>';
      this.header.find('.text-content').html('');
      this.modal.find('.modal-content').attr({ 'class': 'modal-content success' });
    } else {
      iconHtml = '<span class="modal-type-icon"><i class="fa fa-triangle-exclamation"></i></span>';
      this.header.find('.text-content').html('Something Went Wrong');
      this.modal.find('.modal-content').attr({ 'class': 'modal-content error' });
    }


    if(iconHtml && !cfg.classicalModal) {
      this.modal.find('.modal-content').prepend(iconHtml);
    }

    if(cfg.classicalModal){
      this.header.find('.text-content').html('');
      this.modal.find('.modal-content').removeClass('message').removeClass('success').removeClass('error');
    }

    if(cfg.html) this.body.find('.text-content').html(cfg.html);
    if(cfg.append) this.body.find('.text-content').html('').append(cfg.append);

    this.yesBtn.css({display: cfg.withoutYes ? 'none' : 'inline-block'})
    this.onHide = cfg.onHide || null;
    this.noBtn.css({display: !cfg.no ? 'none' : 'inline-block'}).unbind('click').click(() => {
      this.onHide && this.onHide('no');
    })

    this.onYes = cfg.callback || null;

    this.yesBtn.removeClass('btn-default btn-danger btn-info btn-primary btn-success btn-warning').addClass(cfg.yesClass || 'btn-primary')

    this.modal.modal('show');
  },

  hide: function () {
    this.modal.modal('hide');
  }
};

$(function () {
  Modal.init();
});